/// \file popup.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.
import React, { Fragment } from 'react';
// visible = is a boolean to indiciate whether the rest of the dialog will show
// title = is the title of the dialog popup box
// body = is the body of the dialog popup box
// toggleDialogClose = is the action when the dialog is closed;
// closeButtonName = is the name of the close button on the lower right corner of the dialog
// extraButtons = contains any additional buttons next to the close button

export const Popup = (props:{
    visible:boolean,
    title:string,
    body:any, //JSX.Element
    toggleDialogClose:any,
    closeButtonName:string,
    extraButtons:{id:string,name:string,className:string,onClick:any}[],
    noscroll?:boolean
}) => {
    const visible = props.visible;
    const title = props.title
    const body = props.body;
    const toggleDialogClose = props.toggleDialogClose;
    const closeButtonName = props.closeButtonName;
    const extraButtons = props.extraButtons;
    const noscroll = props.noscroll;
    var scrollableClass = "";
    if(noscroll){
        scrollableClass = " noscroll"
    }
    return (
        <Fragment>
        {visible && <Fragment>
            <div className="dialogBackground">
                <dialog className={"customDialog" + scrollableClass}>
                    <div className="dialogTitle">
                        <h4 className="dialogTitleText">{title}</h4> <button onClick={toggleDialogClose} className = "dialogXButton">X</button>
                    </div>
                    <div className={"dialogBody" + scrollableClass}>
                        {body}
                    </div>
                    <div className="dialogFooter">
                        {extraButtons.map((extraButton:any, index) => <button key={extraButton.id+"-"+extraButton.name + index.toString()} id={extraButton.id} className={extraButton.className} onClick={extraButton.onClick}>{extraButton.name}</button>)}
                        <button className="defaultbutton" onClick={toggleDialogClose}>{closeButtonName}</button>
                    </div>
                </dialog>
            </div>
        </Fragment>
      }
      </Fragment>
    );
};